import { h, Component } from 'preact';
import { translate } from 'react-i18next';
import { Link } from 'preact-router/match';

import Navigation from '../components/Navigation.js';

class AccountOverview extends Component {

	openNav = () => {
		if (this.state.displayNav === true && this.props.windowWidth <= 800) {
			this.setState({ displayNav: false });
			document.body.classList.remove('shift');
			document.getElementById('acct').classList.remove('move');
			document.documentElement.style.overflow = 'auto';
			document.body.scroll = 'yes';
		}
		else if (this.state.displayNav === false && this.props.windowWidth <= 800) {
			this.setState({ displayNav: true });
			document.body.classList.add('shift');
			document.getElementById('acct').classList.add('move');
			document.documentElement.style.overflow = 'hidden';
			document.body.scroll = 'no';
		}
		else if (this.state.displayNav === true && this.props.windowWidth > 800) {
			this.setState({ displayNav: false });
			document.body.classList.remove('shift');
			document.getElementById('acct').classList.remove('move');
		}
		else if (this.state.displayNav === false && this.props.windowWidth > 800) {
			this.setState({ displayNav: true });
			document.body.classList.add('shift');
			document.getElementById('acct').classList.add('move');

		}
	}

	constructor(props) {
		super(props);
		this.state = {
			displayNav: false
		};
	}

	componentDidMount() {
		{/* TODO: Check if cookies exist and call account information otherwise display AccountPanel */ }
	}

	render() {
		const { t } = this.props;
		if (this.state.windowWidth >= 1200) {
			return (
				<header className="account-overview">
					<Link className="logo" href="/">
						<img src="https://webcdn.hirezstudios.com/hirez-studios/wp-content/uploads/2018/03/Logo_Hi-Rez_White_1c_R.png" alt="Hi-Rez Studios Logo" />
					</Link>
					<div className="links">
						<div className="link">{t('Games')}</div>
						<div className="link">{t('Language')}</div>
					</div>
				</header>
			);
		}
		return (
			<header className="account-overview" id="acct">
				<div className={`mobile-nav ${this.props.windowWidth < 1200 ? 'active' : ''}`}  onClick={() => this.openNav()} >
					<img src="https://webcdn.hirezstudios.com/account-services/mobile-icons.png" alt="" />
					<div id="display-nav" className={`${this.state.displayNav ? 'active' : ''}`}>
						<Navigation windowWidth={this.state.windowWidth} chatActive={this.state.chatActive} />
					</div>
				</div>
				<Link className="logo" href="/">
					<img src="https://webcdn.hirezstudios.com/hirez-studios/wp-content/uploads/2018/03/Logo_Hi-Rez_White_1c_R.png" alt="Hi-Rez Studios Logo" />
				</Link>
				<div className="links">
					<div className="link">{t('Games')}</div>
					<div className="link">{t('Language')}</div>
				</div>
			</header>
		);
	}
}

export default translate(['common'], { withRef: true })(AccountOverview);


// WEBPACK FOOTER //
// ./components/AccountOverview.js